<template></template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("auth", ["logout"])
  },
  created() {
    this.logout().then(response => {
      //currentAccount
      this.$cookies.remove("currentAccount");
      this.$router.push({ name: "login" });
    });
  }
};
</script>

<style>
</style>
